const LicenceTypeValuesAlberta = {
    CLASS_7: '7',
    CLASS_5_GDL: '5-gdl',
    CLASS_5: '5',
};

const LicenceTypeValuesOntario = {
    G1: 'G1',
    G2: 'G2',
    G: 'G',
};

const LicenceTypeValuesQuebec = {
    CLASS_5L: '5L',
    CLASS_5P: '5P',
    CLASS_5: '5',
};

export {
    LicenceTypeValuesAlberta,
    LicenceTypeValuesOntario,
    LicenceTypeValuesQuebec,
};
